import gql from 'graphql-tag';

const pendingVraNotesQuery = gql`
  query PendingVraNotes($vraId: ID!) {
    pendingVraNotes(vraId: $vraId) {
      returnId
      vra
      notes {
        id
        note
        createdBy
        createdAt
      }
    }
  }
`;

export default pendingVraNotesQuery;
